import React from 'react';
import './Profissionais.css';

function Profissional({ nome, cargo, descricao, descricaoSecundaria, imagem, customClass }) {
  return (
  <section className={`profissional-container ${customClass || ''}`}>
    <div className="profissional-content">
      <h2 className="profissional-nome">{nome}</h2>
      <p className="profissional-cargo">{cargo}</p>

      <div className="profissional-descricao-com-imagem">
        <img src={imagem} alt={nome} className="profissional-img-flutuante" />
        <div className="profissional-descricao">{descricao}</div>
      </div>
    </div>
  </section>
  );
}

export default Profissional;
